/**
 * @description Homepage SEO meta copy (title, description).
 * @filename homepage-meta.ts
 */

/** ~146 characters — fits SERP snippet limit (~155). */
export const HOMEPAGE_META_DESCRIPTION =
  "Radivision®'s Pitch Planet™ platform lets you discover and connect to startups. Watch original series, access startup, private market & IPO resources.";

export const HOMEPAGE_TITLE = "Radivision®: The Entrepreneurship Network";
